export const mapAddressHistoryDefault = (answers: Record<string, any>) => {
    const entries = answers.addressHistory.entries
    const first = entries['1']
    const firstSituation = first.addressSituation

    const updated = Object.keys(entries).reduce((acc, key) => {
        const e = entries[key]
        acc[key] = {
            ...e,
            addressSituation: firstSituation
        }
        return acc
    }, {} as Record<string, typeof entries['1']>)

    return { ...answers.addressHistory, entries: updated }
}

export const mapAddressHistoryMotiv = (answers: Record<string, any>) => {
    const base = mapAddressHistoryDefault(answers)
    const updated = Object.keys(base.entries).reduce((acc, key) => {
        const e = base.entries[key]
        acc[key] = {
            ...e,
            lengthOfTime: { years: '3', months: '0' }
        }
        return acc
    }, {} as Record<string, typeof base.entries['1']>)
    return { ...base, entries: updated }
}